var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwoDirectional = function SvgTwoDirectional(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 60,
    viewBox: "0 0 88 60",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 33.8l19.8 19.8c1.5 1.5 1.5 3.8 0 5.3 -1.5 1.5-3.8 1.5-5.3 0l-26.2-26.2c0 0 0 0 0 0 -0.7-0.7-1.1-1.6-1.1-2.6l0 0c0-0.5 0.1-1 0.3-1.4 0.2-0.4 0.4-0.8 0.8-1.2 0 0 0 0 0 0l26.2-26.2c1.5-1.5 3.8-1.5 5.3 0 1.5 1.5 1.5 3.8 0 5.3l-19.8 19.8 62.4 0 -19.8-19.8c-1.5-1.5-1.5-3.8 0-5.3 1.5-1.5 3.8-1.5 5.3 0l26.2 26.2c0 0 0 0 0 0 0.3 0.4 0.6 0.8 0.8 1.2 0.2 0.4 0.3 0.9 0.3 1.4l0 0c0 1-0.4 1.9-1.1 2.6 0 0 0 0 0 0l-26.2 26.2c-1.5 1.5-3.8 1.5-5.3 0 -1.5-1.5-1.5-3.8 0-5.3l19.8-19.8 -62.4 0Z"
  })));
};
export default SvgTwoDirectional;